<template>
  <div class="AsistenciasTiemposExtra">
    <md-layout md-flex="100" md-align="center" class="m-t-24">
      <md-layout md-flex-xsmall="100" md-flex-small="100" md-flex-medium="100" md-flex-large="90" md-flex-xlarge="70">
        <md-table-card class="w-100">
          <md-toolbar>
            <h1 class="md-title">
              Asignación de tiempos extra
            </h1>
          </md-toolbar>
          <md-table>
            <md-table-header>
              <md-table-row>
                <md-table-head>#emp</md-table-head>
                <md-table-head>Empleado</md-table-head>
                <md-table-head>Fecha reg. falta</md-table-head>
                <md-table-head>Punto</md-table-head>
                <md-table-head>Turno</md-table-head>
                <md-table-head>Acciones</md-table-head>
              </md-table-row>
            </md-table-header>
            <md-table-body>
              <md-table-row v-for="tex in tiemposextra" :key="tex.id_tex">
                <md-table-cell>
                  <div v-if="tex.nombre">
                    {{tex.id_emn}}
                  </div>
                </md-table-cell>
                <md-table-cell>
                  <div v-if="tex.nombre">
                    {{tex.nombre}}
                  </div>
                  <div v-else>
                    VACANTE
                  </div>
                </md-table-cell>
                <md-table-cell>{{moment(tex.fecha_asi,'YYYY-MM-DD h:mm:ss').format('YYYY-MM-DD h:mm A')}}</md-table-cell>
                <md-table-cell>{{tex.nombre_pun}}</md-table-cell>
                <md-table-cell>{{ moment(tex.inicio_ptu,'h:mm:ss').format('h:mm A') }} - {{ moment(tex.termino_ptu,'h:mm:ss').format('h:mm A') }}</md-table-cell>
                <md-table-cell>
                  <md-button style="width:auto" class="md-raised md-accent" @click.native="buscarEmpleadoCubriraPunto(tex)">Asignar cubre vacante</md-button>
                </md-table-cell>
              </md-table-row>
            </md-table-body>
          </md-table>
        </md-table-card>
      </md-layout>
    </md-layout>
    <md-dialog md-open-from="#custom" md-close-to="#custom" ref="modalBuscarEmpleado">
      <md-dialog-content>
        <h2>
          Tiempo extra en punto: {{emp_tex.nombre_pun}} <br>Turno: {{ moment(emp_tex.inicio_ptu,'h:mm:ss').format('h:mm A') }} - {{ moment(emp_tex.termino_ptu,'h:mm:ss').format('h:mm A') }}<br> Cubre a: {{emp_tex.nombre}}
        </h2>
        <md-input-container>
          <md-autocomplete :fetch="fetchFunction" print-attribute="nombre" :debounce="300" :minChars="2" v-model="autocompleteValue" @selected="funcionSelect($event)" />
        </md-input-container>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button @click.native="cerrarModal('modalBuscarEmpleado')">Cancelar</md-button>
        <md-button class="md-primary md-raised" @click.native="asignarEmpleado()">Asignar tiempo extra</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import sha1 from "js-sha1";
import md5 from "blueimp-md5";
import Snackbar from "node-snackbar";
import moment from "moment";
export default {
  name: "AsistenciasPuntos",
  methods: {
    moment(a, b) {
      return moment(a, b);
    },
    obtenerTiemposExtraPendientes() {
      this.$http
        .post("tiemposextra", {
          token: this.$session.get("token")
        })
        .then(
          response => {
            if (response.status === 200 && "tiemposextra" in response.body) {
              this.tiemposextra = response.body.tiemposextra;
            } else {
              Snackbar.show({
                text: response.body.error,
                actionText: "Cerrar",
                pos: "top-right",
                showAction: false,
                backgroundColor: "#F44336",
                actionTextColor: "#FFF"
              });
            }
          },
          response => {
            Snackbar.show({
              text: "No se pudo establecer conexión con el servidor.",
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false,
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        );
    },
    buscarEmpleadoCubriraPunto(tex) {
      this.emp_tex = tex;
      this.abrirModal("modalBuscarEmpleado");
    },
    asignarEmpleado() {
      if (this.texEmpleado) {
        this.$http
          .post("tiemposextra/asignar", {
            token: this.$session.get("token"),
            data: {
              asistencia: this.emp_tex.id_asd,
              recibe: this.texEmpleado.id_emn
            }
          })
          .then(
            response => {
              if (response.status === 200 && "msg" in response.body) {
                Snackbar.show({
                  text: response.body.msg,
                  actionText: "Cerrar",
                  pos: "top-right",
                  showAction: false
                });
              } else {
                Snackbar.show({
                  text: response.body.error,
                  actionText: "Cerrar",
                  pos: "top-right",
                  showAction: false,
                  backgroundColor: "#F44336",
                  actionTextColor: "#FFF"
                });
              }
              this.obtenerTiemposExtraPendientes();
              this.emp_tex.nombre = null;
              this.emp_tex.id_emn = null;
              this.texEmpleado = null;
              this.cerrarModal("modalBuscarEmpleado");
            },
            response => {
              Snackbar.show({
                text: "No se pudo establecer conexión con el servidor.",
                actionText: "Cerrar",
                pos: "top-right",
                showAction: false,
                backgroundColor: "#F44336",
                actionTextColor: "#FFF"
              });
            }
          );
      } else {
        Snackbar.show({
          text: "Seleccione el empleado al que se le asignará el tiempo extra.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      }
    },
    abrirModal(ref) {
      this.$refs[ref].open();
    },
    cerrarModal(ref) {
      this.$refs[ref].close();
    },
    fetchFunction(param) {
      return this.$http
        .post("empleados/buscar", {
          token: this.$session.get("token"),
          query: param.q
        })
        .then(
          function(response) {
            return response.body;
          },
          response => {}
        );
    },
    funcionSelect(e) {
      this.texEmpleado = e;
    }
  },
  created() {
    this.obtenerTiemposExtraPendientes();
  },
  beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  data() {
    return {
      msg: "Inicio",
      tiemposextra: null,
      emp_tex: {
        nombre: null,
        id_emn: null
      },
      texEmpleado: null,
      empleado: null,
      autocompleteValue: null
    };
  }
};
</script>


// WEBPACK FOOTER //
// AsistenciasTiemposExtra.vue?3b7b69eb